import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../../environments/environment';

import { MessageService } from '../message.service';
import { ProcessDefinition } from '../process-definition';
import { ProcessInstance } from '../process-instance';
import { QueryMetaData } from '../query-metadata';
import { RepoService } from '../repo.service';
import { ProfileService } from '../profile.service';

@Component({
    selector: 'app-process-start',
    templateUrl: './process-start.component.html',
    styleUrls: ['./process-start.component.scss'],
    standalone: false
})
export class ProcessStartComponent implements OnInit {

  repoService = inject(RepoService);
  route = inject(ActivatedRoute);
  messageService = inject(MessageService);
  private profileService = inject(ProfileService);
  private cdr = inject(ChangeDetectorRef);

  procDefs: ProcessDefinition[];
  selectedProcDef: ProcessDefinition;
  procInst: ProcessInstance;
  query: QueryMetaData;

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
        const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
        const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.query = { start, size } as QueryMetaData;

        // Wait for profile to be loaded before fetching process definitions
        if (this.profileService.isAuthenticated()) {
          this.getProcessDefinitions(this.query);
        } else {
          // Listen for profile loaded event
          window.addEventListener('profile:loaded', () => {
            this.getProcessDefinitions(this.query);
          }, { once: true });
        }
      }
    );
  }

  getProcessDefinitions(query: QueryMetaData): void {
    this.repoService.getProcessDefinitions(query)
        .subscribe(procDefs => {
          this.procDefs = procDefs;
          this.cdr.detectChanges();
        });
  }

  /** Start process instance without any inputs (no start form) */
  onSelect(procDef: ProcessDefinition): void {
    this.selectedProcDef = procDef;
    this.messageService.set(`Process definition selected id=${procDef.id}`);
    this.repoService
      .startInstance(procDef.id)
      .subscribe(procInst => {
        this.procInst = procInst;
        this.cdr.detectChanges();
      });
  }
}
